import axios from 'axios'

const API_URL = process.env.EASI_API_URL || 'https://easi-api.herokuapp.com/api/v1'

export default axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})



// WEBPACK FOOTER //
// ./src/api/vue-axios/axios.js